/**
 * Blockchain Contract Constants
 * Stores information related to Contracts.
 */
export const ContractConstants = Object.freeze({
    METHOD: {
        INIT_CONTRACT: 'initContract',
        DEPOSIT: 'deposit',
        CONFIRM_WORK_COMPLETION: 'confirmWorkCompletion'
    }
})